import * as M from '@mantine/core';
import * as C from '../../../../../../ui/common/CommonStyles';
import { ApiResponse } from '../../../../../../../shared/types/response/types';
import { IAiAgentServiceOperationSettingsHistory } from '../../../../../../../shared/apis/ai-agent/company/types';
import { handleChangeLocaleTime } from '../../../../../../../shared/utils/time';
import HoverCardText from '../../../../../../ui/hoverCardText';
import { filterAiAgentTargetServices } from '../../../../../../../shared/utils/aiAgentServiceChannel';

const tableHead = [
  '번호',
  '계약된 그룹 수',
  '사용중인 서비스',
  '학습 페이지 제한 수',
  '계정 제한 수',
  '회사 일 질답 총한도',
  '사전 제한 수',
  '피드백 관리',
  '메모',
  '수정 담당자',
  '수정일시',
];

export default function OperationHistoryTable(props: {
  data?: ApiResponse<IAiAgentServiceOperationSettingsHistory>;
  page: number;
  size: number;
  onPageChange: (page: number) => void;
}) {
  const { data, page, size, onPageChange } = props;

  return (
    <M.Box mt="lg">
      <M.Text fw={600} mb="sm">
        설정 이력
      </M.Text>
      <C.TableWrap>
        <M.Table.ScrollContainer minWidth={1400}>
          <M.Table
            withTableBorder
            withColumnBorders
            styles={{
              th: { textAlign: 'center' },
              td: { textAlign: 'center' },
            }}
          >
            <M.Table.Thead>
              <M.Table.Tr>
                <M.Table.Th rowSpan={2} ta="center">
                  번호
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  계약된 <br />
                  그룹 수
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  사용 중인 서비스
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  각 서비스 계정 <br />
                  가입 제한 수
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  학습 페이지 <br /> 제한 수
                </M.Table.Th>
                <M.Table.Th colSpan={3} ta="center">
                  질답 한도
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  사전 제한 수
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  피드백 관리
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  메모
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  수정 담당자
                </M.Table.Th>
                <M.Table.Th rowSpan={2} ta="center">
                  수정 일시
                </M.Table.Th>
              </M.Table.Tr>

              <M.Table.Tr>
                <M.Table.Th ta="center">회사 월 제한</M.Table.Th>
                <M.Table.Th ta="center">회사 일 제한</M.Table.Th>
                <M.Table.Th ta="center" style={{ borderRight: '1px solid var(--table-border-color)' }}>
                  계정 일 제한
                </M.Table.Th>
              </M.Table.Tr>
            </M.Table.Thead>
            <M.Table.Tbody>
              {data && data.result.length > 0 ? (
                data.result.map((item, index) => (
                  <M.Table.Tr key={item.historyId}>
                    <M.Table.Td>{(data.count ?? 0) - ((page - 1) * size + (index ?? 0))}</M.Table.Td>
                    <M.Table.Td>
                      <M.NumberFormatter value={item.contractedGroupCount} thousandSeparator />
                    </M.Table.Td>
                    <M.Table.Td>
                      <M.Group gap={4} justify="center">
                        {filterAiAgentTargetServices(item.channels).map((channel) => (
                          <M.Badge
                            key={channel}
                            variant="light"
                            color={channel === 'SCAUTR' ? 'green' : channel === 'PROGIX' ? 'blue' : 'navy'}
                          >
                            {channel}
                          </M.Badge>
                        ))}
                      </M.Group>
                    </M.Table.Td>
                    <M.Table.Td>
                      <M.NumberFormatter value={item.accountLimit} thousandSeparator />
                    </M.Table.Td>{' '}
                    <M.Table.Td>
                      <M.NumberFormatter value={item.pageLimit} thousandSeparator />
                    </M.Table.Td>
                    <M.Table.Td>
                      {item.companyChatTurnLimitMonthly === null ? (
                        '-'
                      ) : (
                        <M.NumberFormatter value={item.companyChatTurnLimitMonthly} thousandSeparator />
                      )}
                    </M.Table.Td>
                    <M.Table.Td>
                      {item.companyChatTurnLimitDaily === null ? (
                        '-'
                      ) : (
                        <M.NumberFormatter value={item.companyChatTurnLimitDaily} thousandSeparator />
                      )}
                    </M.Table.Td>
                    <M.Table.Td>
                      {item.userChatTurnLimitDaily === null ? (
                        '-'
                      ) : (
                        <M.NumberFormatter value={item.userChatTurnLimitDaily} thousandSeparator />
                      )}
                    </M.Table.Td>
                    <M.Table.Td>
                      <M.NumberFormatter value={item.dictionaryLimit} thousandSeparator />
                    </M.Table.Td>
                    <M.Table.Td>{item.feedbackManageYn === 'Y' ? '사용' : '미사용'}</M.Table.Td>
                    <M.Table.Td maw={200} ta="left">
                      <HoverCardText value={item.memo || '-'} />
                    </M.Table.Td>
                    <M.Table.Td ta="left">{item.registeredByEmail}</M.Table.Td>
                    <M.Table.Td>{handleChangeLocaleTime(item.registeredAt)}</M.Table.Td>
                  </M.Table.Tr>
                ))
              ) : (
                <M.Table.Tr>
                  <M.Table.Td colSpan={13}>
                    <M.Stack gap={4} py="xl" align="center">
                      <M.Text size="sm">데이터가 없습니다.</M.Text>
                    </M.Stack>
                  </M.Table.Td>
                </M.Table.Tr>
              )}
            </M.Table.Tbody>
          </M.Table>
        </M.Table.ScrollContainer>
      </C.TableWrap>
      <M.Group justify="center" mt="md">
        <M.Pagination total={Math.ceil((data?.count || 0) / size)} value={page} onChange={onPageChange} />
      </M.Group>
    </M.Box>
  );
}
